class Character {
  constructor(v) {
    this.name = v.name;
    this.id = v.id;
    this.hp = v.hp;
    this.mp = v.mp;
    this.ap = v.ap;
    this.attack = v.attack;
    this.defense = v.defense;
    this.equipment = {
      head: null,
      arms: null,
      chest: null,
      feet: null,
      mainHand: null,
      offHand: null,
    };
  }
  isDead() {
    return this.hp.cur <= 0 ? 1 : 0;
  }
  getAttackRange() {
    let min = this.attack;
    let max = this.attack;
    for (let e in this.equipment) {
      if (this.equipment[e]) {
        min += this.equipment[e].attackRange.min;
      }
      if (this.equipment[e]) {
        max += this.equipment[e].attackRange.max;
      }
    }
    return {
      min: min,
      max: max,
    };
  }
  getTotalDefense() {
    let def = this.defense;
    for (let e in this.equipment) {
      if (this.equipment[e]) {
        def += this.equipment[e].defense;
      }
    }
    return def;
  }
}

export default Character;
